import { NOT_FOUND } from 'redux-first-router';

const components = {
  DEFAULT_LANDER: 'Lander',
  DEFAULT_ARTICLE: 'Article/Article',
  LANDER: 'Lander',
  ARTICLE: 'Article/Article'
};

export default (state = 'DEFAULT_LANDER', action = {}) => components[action.type] || state;

// NOTES: this is the primary reducer demonstrating how RFR replaces the need
// for React Router's <Route /> component.
//
// ALSO:  Forget a switch, use a hash table for perf.
